function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.8442 0.313127C8.7452 0.21387 8.62758 0.135121 8.49809 0.0813893C8.36861 0.0276578 8.22979 0 8.08959 0C7.9494 0 7.81059 0.0276578 7.6811 0.0813893C7.55161 0.135121 7.43399 0.21387 7.33499 0.313127L0.249356 7.39876C0.170312 7.47764 0.1076 7.57134 0.0648123 7.67449C0.0220245 7.77764 0 7.88822 0 7.99989C0 8.11156 0.0220245 8.22213 0.0648123 8.32528C0.1076 8.42843 0.170312 8.52213 0.249356 8.60101L7.33499 15.6866C7.75279 16.1045 8.4264 16.1045 8.8442 15.6866C9.26201 15.2688 9.26201 14.5952 8.8442 14.1774L2.67092 7.99562L8.85273 1.81381C9.26201 1.40454 9.26201 0.722406 8.8442 0.313127Z",
  fill: "#666666"
});
function SvgIconArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 16,
    viewBox: "0 0 10 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowLeft);
export default __webpack_public_path__ + "static/media/iconArrowLeft.3c1cfbe2.svg";
export { ForwardRef as ReactComponent };